import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import Button from '@/components/ui/Button'

const NotFound = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-heading-xl font-bold">
          {t('errors.notFound.code')}
        </h1>
        <p className="mb-4 text-heading text-muted-foreground">
          {t('errors.notFound.title')}
        </p>
        <Button
          variant="text"
          onClick={() => navigate({ to: '/' })}
          className="text-primary underline hover:text-primary/90"
        >
          {t('errors.notFound.returnHome')}
        </Button>
      </div>
    </div>
  )
}

export default NotFound
